module.exports = __webpack_public_path__ + "img/arrow_left_square.03f0adf7.svg";